import { ACCOUNT_TABS, navigate, type AccountTab } from '../lib/route.ts'

/**
 * The parts of an account's page, a tab each (#688).
 *
 * Tabs navigate rather than swap state, as on Relatórios, so each part has an
 * address that survives a reload and can be sent to somebody. One line that
 * scrolls sideways on a narrow screen, rather than wrapping under itself.
 */
export const ACCOUNT_TAB_LABEL: Readonly<Record<AccountTab, string>> = {
  details: 'Dados',
  rules: 'Regras operacionais',
  connection: 'Conexão',
  stages: 'Etapas da bancada',
  'read-window': 'Janela de leitura',
  'erp-codes': 'Códigos do ERP',
}

export function AccountTabs({ accountId, active }: { accountId: string; active: AccountTab }) {
  return (
    <div className="border-stroke-weak flex gap-1 overflow-x-auto border-b" role="tablist">
      {ACCOUNT_TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={active === tab}
          onClick={() => navigate({ name: 'account', id: accountId, tab })}
          className={
            active === tab
              ? 'text-tPSemi text-text-brand border-fill-brand -mb-px border-b-2 px-3 py-2 whitespace-nowrap'
              : 'text-tP text-text-weak hover:text-text-strong -mb-px border-b-2 border-transparent px-3 py-2 whitespace-nowrap'
          }
        >
          {ACCOUNT_TAB_LABEL[tab]}
        </button>
      ))}
    </div>
  )
}
